import React from 'react';
import PageMeta from '../components/common/PageMeta';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import FinancialServicesPage from "../pages/financial-services/FinancialServicesPage";
import Footer from "../components/Home/Footer";
import IntegrationOptions from "../pages/financial-services/IntegrationOptions";
import Benefits from "../pages/financial-services/Benefits";

const FinancialServices = () => {
  return (
    <Layout>
      <PageMeta title='Sunlex' />
      <Navbar classOption='navbar-light' />
      <FinancialServicesPage />
      <IntegrationOptions />
      <Benefits />
      <Footer />
    </Layout>
  );
};

export default FinancialServices;
